export * from './EducationIntro'
